var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBizLg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2439_7766",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 43,
    height: 43
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4568 21.3482C42.4568 32.9146 33.0804 42.291 21.514 42.291C9.94767 42.291 0.571289 32.9146 0.571289 21.3482C0.571289 9.7819 9.94767 0.405518 21.514 0.405518C33.0804 0.405518 42.4568 9.7819 42.4568 21.3482Z",
    fill: "#FFB4B4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2439_7766)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7601 0.417114C9.54294 0.814029 0.571289 10.0326 0.571289 21.3465C0.571289 28.4214 4.07941 34.6768 9.45101 38.4683V29.6793C7.81344 27.3132 6.85411 24.4419 6.85411 21.3465C6.85411 13.5029 13.014 7.09808 20.7601 6.70567V0.417114ZM11.2521 31.8158C13.7103 34.2256 17.0136 35.7766 20.6763 35.9829V42.2728C17.2614 42.1385 14.0565 41.1864 11.2521 39.607V31.8158ZM22.5612 42.2635V35.9696C26.2449 35.7096 29.553 34.0886 31.9854 31.6063V39.4875C29.1885 41.1054 25.9828 42.0951 22.5612 42.2635ZM40.5256 12.5506C41.765 15.225 42.4568 18.205 42.4568 21.3465C42.4568 28.2918 39.0759 34.4475 33.8702 38.2575V29.239C35.3285 26.9606 36.1739 24.2523 36.1739 21.3465C36.1739 18.4407 35.3285 15.7324 33.8702 13.4541V12.5506H40.5256ZM22.5612 0.429519C25.9828 0.598007 29.1885 1.58767 31.9854 3.20556V11.0867C29.553 8.60445 26.2449 6.98342 22.5612 6.72344V0.429519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9862 -2.69165H22.562L22.562 42.2933H31.9862V-2.69165ZM20.6772 24.4082L11.2529 24.4082L11.2529 42.2933H20.6772V24.4082ZM33.8711 42.2933H43.2953V12.5547H33.8711V42.2933Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBizLg);
export default __webpack_public_path__ + "static/media/bizLg.f4cb6891c67a8fb1ff65d15c922b4bba.svg";
export { ForwardRef as ReactComponent };